export default "__VITE_ASSET__b9c98b5f__"